import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
  useMemo,
  useRef,
} from "react";
import "./style.css";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../redux/store";
import { resetFormData } from "../../redux/reducer";
import { setDialogModalOptions } from "../../redux/modelDialogReducer";
import { useNavigate } from "react-router-dom";
import {
  Eye16Filled,
  MoreHorizontal24Filled,
  Edit16Filled,
  ArrowDownload20Filled,
  ChevronDownRegular,
  ArrowSwap20Regular,
  FilterDismiss20Regular,
  ArrowClockwise20Regular,
} from "@fluentui/react-icons";
import {
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  Drawer,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  Checkbox,
  Toolbar,
  ToolbarGroup,
  ToolbarButton,
  makeStyles,
} from "@fluentui/react-components";
import ClientActionPage from "./ClientActionPage";
import ModalDialog from "../../components/ModalDialog";
import { fetchSettings } from "../../redux/formSlice";
import { checkUserPermission, convertStringToArray } from "../../utils";
import { UserPermissionsList } from "../../config";
import apiServices from "../../service";
import { ExtractMain } from "../utilities/ExtractLocate/extractMain";
import { setReloadClientList } from "../../redux/formUpdateReducer";
import { resetActiveClientState } from "../../redux/activeClientSlice";
import { setActiveCustmer } from "../../redux/timerSlice";
import { ValuePrediction } from "./SavedSearch/ValuePrediction";
import { setString } from "../../redux/SavedSearch/searchId";
import { setSelectionType } from "../../redux/SavedSearch/extractTypes";
import MaterialReactTable, {
  MRT_VisibilityState,
  type MRT_ColumnDef,
  type MRT_PaginationState,
  MRT_SortingState,
  MRT_RowSelectionState,
} from "material-react-table";
import defaultTableConfig from "../../shared/tableConfig.json";
import {
  Button,
  Tooltip,
  Menu,
  MenuTrigger,
  MenuList,
  MenuItem,
  MenuPopover,
  Label,
  shorthands,
  Toaster,
  useToastController,
  ToastTitle,
  Toast,
  ToastBody,
  ToastTrigger,
  Link,
} from "@fluentui/react-components";
import { ClientDataType } from "../../types";
import Search from "../../components/Search";
import DropDownBox from "../../components/DropDownBox";
import ASCButton from "../../components/Button";
import ASCDropDown from "../../components/DropDown";
import ReactQuillComponent from "../../components/ReactQuillComponent";
import { debounce } from "lodash";
import isEqual from "lodash/isEqual";
import SendMail from "./SendMail";
import { IconButton } from "@mui/material";
import { resetReloadClientList } from "../../redux/formUpdateReducer";
import ExportMain from "../Export/ExportMain";
import MainPage from "../ClientPartnerSplit/MainPage";
import {
  setClientValue,
  setFilterSelectionData,
  setPartnerIDs,
} from "../../redux/clientSlice";
import MainTab from "./SavedSearch/MainTab";
import { TableListLoader } from "../../components/Loader/TableListLoader";
import { clearString } from "../../redux/SavedSearch/searchId";
import { clearSearch } from "../../redux/SavedSearch/updateSearchId";
import { clearSelectionType } from "../../redux/SavedSearch/extractTypes";
import {
  fetchUserPreferences,
  savePreferences,
  selectDefaultConfig,
  selectPreferenceStatus,
  selectTableColumnOrder,
  selectTableColumns,
  setTableColumnOrder,
  setTableSorting,
  setTablePagination,
  resetTableToDefault,
  selectTableSorting,
  selectTablePagination,
  selectTableSortingConfig,
} from "../../redux/userPreferenceSlice";
import { useToastMessage } from "../../components/ToastMessage/ToastMessage";
import { formatedDate } from "../../utils";
import {
  clearClientListQueries,
  fetchClientLists,
  selectClientListQueries,
  setClientListQueries,
} from "../../redux/Client/clientListSlice";

interface PropsType {
  setTabs?: Dispatch<SetStateAction<string>>;
  [x: string]: any;
}
interface OptionType {
  label: string;
  value: string;
}

const useStyles = makeStyles({
  toolbar: {
    justifyContent: "space-between",
  },
  fullWidthItem: {
    width: "100%",
    justifyContent: "flex-start",
    backgroundColor: "#FAFAFF",
    borderRadius: "3px",
    height: "25px",
    alignItems: "center",
    display: "flex",
    "&:hover": {
      backgroundColor: "#E0E0E0",
    },
  },
  fullWidthContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    maxHeight: "160px",
    overflowX: "auto",
    padding: "2px",
    gap: "3px",
  },
  wrapper: {
    columnGap: "15px",
    display: "flex",
    cursor: "pointer",
  },
  contentHeader: {
    marginTop: "0",
  },
  scopeArea: {
    display: "grid",
    gridTemplateRows: "repeat(1fr)",
    justifyItems: "start",
    ...shorthands.gap("2px"),
    maxWidth: "400px",
  },
  popup: {
    height: "auto",
    width: "auto",
    position: "absolute",
    backgroundColor: "white",
    ...shorthands.padding("10px"),
    zIndex: 1000,
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    alignItems: "center",
    cursor: "pointer",
  },
});

const scopeData: {
  value: any;
  label: string;
}[] = [
  {
    value: "client",
    label: "Client",
  },
  {
    value: "partner",
    label: "Partner",
  },
];
enum TabValues {
  ExportByCondition = "tab1",
  ExportBySelection = "tab2",
}

const List = ({ setTabs, module, formAction }: PropsType) => {
  const [selectedTab, setSelectedTab] = useState<TabValues>(
    TabValues.ExportByCondition
  );
  const [extract, setExtract] = useState<{ [key: string]: any }[]>([]);
  const [encodedCondition, setEncodedCondition] = useState<string | null>(null);
  const navigate = useNavigate();
  const [selectedSearches, setSelectedSearches] = useState<any>([]);
  const styles = useStyles();
  const [typeOfExtract, setTypeOfExtract] = useState<any>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [reloadList, setReloadList] = useState(false);
  const [page, setPage] = useState("listing");
  const [leftTabMenu, setLeftTabmenu] = useState("Client");
  const [clientFormSubmited, setClientFormSubmitted] = useState(false);
  const [drawerSize, setDrawerSize] = useState("small");
  const [activeClient, setActiveClient] = useState<{ [key: string]: any }>({});
  const [activeCustomerId, setActiveCustomerId] = useState<string | null>(null);
  const [activePartnerId, setActivePartnerId] = useState<string | null>(null);
  const [search, setSearch] = useState("");
  const [searchValue, setSearchValue] = useState(""); // Immediate value for UI
  const [selectedScope, setSelectedScope] = useState<any>([]);
  const [clientTypeList, setClientTypeList] = useState<any>([]);
  const [applyFilter, setApplyFilter] = useState(false);
  const [selectedClientType, setSelectedClientType] = useState<string[]>([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedSearch, setSelectedSearch] = useState<string>("");
  const [formDataUpdated, setFormDataUpdated] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedClientTypeMenu, setSelectedClientTypeMenu] =
    useState("ClientType");
  const [isLoadingSkeleton, setIsLoadingSkeleton] = useState(false);
  const [handleCondition, setHandleCondition] = useState([]);
  const [searchIds, setSearchIds] = useState<any>("");
  const [tabOpen, setTabOpen] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [selectedItemTwo, setSelectedItemTwo] = useState("");
  const [selectedFieldName, setSelectedFieldName] = useState("");
  const [selectedFieldNameTableTwo, setSelectedFieldNameTableTwo] =
    useState("");
  const [selectedTableName, setSelectedTableName] = useState("");
  const [selectedTableNameTwo, setSelectedTableNameTwo] = useState("");
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [selectedColumnNameTwo, setSelectedColumnNameTwo] = useState("");
  const [hasTableOne, setHasTableOne] = useState(false);
  const [hasTableTwo, setHasTableTwo] = useState(false);
  const [isPartner, setIsPartner] = useState(false);
  const [selectedFieldType, setSelectedFieldType] = useState("");
  const [selectedFiledTypeTableTwo, setSelectedFieldTypeTableTwo] =
    useState("");

  const [isDialogOpens, setIsDialogOpens] = useState(false);
  const [initialLoader, setInitialLoader] = useState<boolean>(false);
  const [selectedItems, setSelectedItems] = useState<{
    [key: string]: any;
  }>({});

  // Merged states from ClientDataList
  const [hasChanges, setHasChanges] = useState(false);
  const [popupData, setPopupData] = useState<string | null>(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [isSendMailDialogOpen, setSendMailDialogOpen] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [IsContentloading, setIsContentLoading] = useState(false);
  const [openSplit, setOpenSplit] = useState<boolean>(false);
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [ClientPartner, setClientPartner] = useState<any>(null);
  const [partnerID, setPartnerID] = useState("");
  const [client, setClient] = useState<ClientDataType[]>([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [selectClient, setSelectClient] = useState<{
    customer_id: string;
    first_names: string;
    last_name: string;
  }>({ customer_id: "", first_names: "", last_name: "" });
  const [columnOrder, setColumnOrder] = useState<string[]>([]);
  const queries = useSelector(selectClientListQueries);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: queries.page ? queries.page : 0,
    pageSize: queries.limit ? queries.limit : 100,
  });
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnVisibility, setColumnVisibility] = useState<MRT_VisibilityState>(
    {
      initials: false,
      former_last_name: false,
    }
  );

  // const isFirstRender = useRef(true);
  const tableName = "CLIENT_DETAILS";
  const dispatch: AppDispatch = useDispatch();
  const { showToast, toasterId } = useToastMessage();

  const isFormDataUpdated: boolean = useSelector(
    (state: RootState) => state.someReducer?.isFormDataUpdated
  );
  const isFormupdated = useSelector(
    (state: RootState) => state.formUpdated?.isFormUpdated
  );
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);
  const loggedUser = useSelector((state: RootState) => state.authUser);
  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const isReloadClientList = useSelector(
    (state: RootState) => state.formUpdated.isReloadClientList
  );
  const filterSelectionData = useSelector(
    (state: RootState) => state.selectionFilter.storedValue
  );
  // Redux selectors for saved preferences
  const rawColumns = useSelector(selectTableColumns(tableName));
  const rawSavedColumnOrder = useSelector(selectTableColumnOrder(tableName));
  const rawSavedSorting = useSelector(selectTableSorting(tableName));
  const rawSavedPagination = useSelector(selectTablePagination(tableName));
  const rawSortingConfig = useSelector(selectTableSortingConfig(tableName));
  const defaultConfig = useSelector(selectDefaultConfig);
  const preferenceStatus = useSelector(selectPreferenceStatus);

  const rawTables = useSelector(
    (state: RootState) => state.userPreferences.preferences?.tables
  );
  const rawContextSpecific = useSelector(
    (state: RootState) =>
      state.userPreferences.preferences?.tables?.contextSpecific
  );
  const rawTableSettings = useSelector(
    (state: RootState) =>
      state.userPreferences.preferences?.tables?.contextSpecific?.[tableName]
  );
  const rawTableInitialState = useSelector(
    (state: RootState) =>
      state.userPreferences.preferences?.tables?.contextSpecific?.[tableName]
        ?.initialState
  );
  const userPreferences = useSelector(
    (state: RootState) => state.userPreferences.preferences
  );
  // Memoized stable versions with defaults
  const columns = useMemo(
    () =>
      rawColumns ??
      defaultTableConfig.tables.contextSpecific[tableName]?.columns ??
      [],
    [rawColumns]
  );
  const savedColumnOrder = useMemo(
    () =>
      rawSavedColumnOrder ??
      defaultTableConfig.tables.contextSpecific[tableName]?.initialState
        ?.columnOrder ??
      [],
    [rawSavedColumnOrder]
  );
  const savedSorting = useMemo(
    () => rawSavedSorting ?? rawSortingConfig?.defaultSort ?? [],
    [rawSavedSorting, rawSortingConfig]
  );
  const savedPagination = useMemo(
    () => rawSavedPagination ?? { pageIndex: 0, pageSize: 100 },
    [rawSavedPagination]
  );
  const savedColumnOrderKey = JSON.stringify(savedColumnOrder);
  const savedSortingKey = JSON.stringify(savedSorting);
  const savedPaginationKey = JSON.stringify(savedPagination);
  const sortingConfig = useMemo(
    () =>
      rawSortingConfig ?? {
        enableMultiSort: false,
        sortableColumns: [],
        defaultSort: [],
      },
    [rawSortingConfig]
  );
  const tables = useMemo(
    () => rawTables ?? { defaultConfig: {}, contextSpecific: {} },
    [rawTables]
  );
  const contextSpecific = useMemo(
    () => rawContextSpecific ?? {},
    [rawContextSpecific]
  );
  const tableSettings = useMemo(
    () => rawTableSettings ?? {},
    [rawTableSettings]
  );
  const tableInitialState = useMemo(
    () => rawTableInitialState ?? {},
    [rawTableInitialState]
  );
  const defaultColumns = useMemo(
    () => defaultTableConfig.tables.contextSpecific[tableName]?.columns ?? [],
    []
  );

  // Debounce for API search, immediate for UI
  useEffect(() => {
    const timer = setTimeout(() => {
      setSearch(searchValue);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchValue]);

  useEffect(() => {
    dispatch(resetActiveClientState());
  }, [dispatch]);

  const changePageMode = (mode: string) => {
    setPage(mode);
    setIsOpen(true);
  };
  const setActiveItem = (item: any) => {
    setActiveClient(item);
    dispatch(setActiveCustmer(item.customer_id));
    setActiveCustomerId(item.customer_id);
    setActivePartnerId(item?.associated_with);
  };
  const closePage = () => {
    setIsOpen(false);
    setActiveCustomerId(null);
    dispatch(setReloadClientList());
    setPage("listing");
  };
  const setFormUpdated = (val: boolean) => {
    setFormDataUpdated(val);
  };
  const getList = () => {
    setReloadList(true);
  };
  const setDialogModal = (options: any) => {
    setDialogModalOptions(options);
  };
  const resetClientFormSubmited = () => {
    setClientFormSubmitted(false);
  };

  const getExtracts = async () => {
    setInitialLoader(true);
    try {
      const response = await apiServices.extract.getExtract();
      const result: any = response.data?.data.filter(
        (item: any) => item.Type === "Condition"
      );

      if (!result.isError) {
        setExtract(result);
      }
    } catch (error) {
      console.error("Failed to fetch extracts:", error);
    } finally {
      setInitialLoader(false);
    }
  };

  useEffect(() => {
    getExtracts();
  }, []);

  useEffect(() => {
    if (
      formSettingsObj &&
      formSettingsObj.data &&
      Object.keys(formSettingsObj.data).length === 0
    ) {
      dispatch(fetchSettings());
    }
  }, [formSettingsObj]);

  useEffect(() => {
    if (formAction != undefined) {
      changePageMode("add");
    }
  }, [formAction]);

  const handleSearchId = (id: any) => {
    setSelectedSearch(id);
    setApplyFilter(true);
  };

  async function fetchClientTypeOptions(): Promise<OptionType[]> {
    const fieldLbl = "client_type:ModifiableList";

    try {
      const res = await apiServices.selectionList.getOptions(fieldLbl);

      if (res.data && res.data.data && res.data.data.length > 0) {
        const options = res.data.data[0].options;

        return options;
      }

      return [];
    } catch (error) {
      console.error("Error fetching client type options:", error);

      return [];
    }
  }

  // Merged functions from ClientDataList
  const handleOpen = () => setIsOpenDialog(true);
  const handleClose = () => setIsOpenDialog(false);
  const handleOpenSearches = () => {
    setTabOpen(true);
  };
  const handleCloseSplit = () => {
    setOpenSplit(false);
    clearExtractFilters();
  };
  const openSendMailDialog = (
    customer_id: string,
    first_names: string,
    last_name: string
  ) => {
    setSendMailDialogOpen(true);
    setSelectClient({ customer_id, first_names, last_name });
  };
  const closeSendMailDialog = () => {
    setSendMailDialogOpen(false);
    setReloadList(true);
  };
  const handleCloseMainTab = () => {
    setTabOpen(false);
  };
  const OpenSplitComponent = (customer_id: any) => {
    setOpenSplit(true);
    dispatch(setClientValue(customer_id));
  };
  const handleSortingChange = (
    updater: MRT_SortingState | ((prev: MRT_SortingState) => MRT_SortingState)
  ) => {
    const newSorting =
      typeof updater === "function" ? updater(sorting) : updater;

    let validatedSorting = newSorting;

    if (sortingConfig?.enableMultiSort === false && newSorting.length > 1) {
      validatedSorting = [newSorting[newSorting.length - 1]];
    }

    if (sortingConfig?.sortableColumns) {
      validatedSorting = validatedSorting.filter((sort) =>
        sortingConfig.sortableColumns.includes(sort.id)
      );
    }

    setSorting(validatedSorting);
  };
  const handlePaginationChange = (
    updater:
      | MRT_PaginationState
      | ((prev: MRT_PaginationState) => MRT_PaginationState)
  ) => {
    const newPagination =
      typeof updater === "function" ? updater(pagination) : updater;
    setPagination(newPagination);
  };
  const handleColumnOrderChange = (
    updater: string[] | ((prev: string[]) => string[])
  ) => {
    const newOrder =
      typeof updater === "function" ? updater(columnOrder) : updater;
    setColumnOrder(newOrder);
  };
  const handleResetToDefault = () => {
    const defaultSort = sortingConfig?.defaultSort || [];
    const defaultPagination = { pageIndex: 0, pageSize: 100 };
    const defaultColumnOrder =
      defaultTableConfig.tables.contextSpecific[tableName]?.initialState
        ?.columnOrder ?? defaultColumns.map((col: any) => col.accessorKey);

    setSorting(defaultSort);
    setPagination(defaultPagination);
    setColumnOrder(defaultColumnOrder);

    setHasChanges(true);
  };
  async function fetchUsersData(
    triggeredBy: "filter" | "pagination" | "reload" = "filter",
    override?: { page?: number; limit?: number }
  ) {
    if (isRestoring.current) {
      return;
    }
    const effectiveScope =
      selectedScope.length > 0
        ? selectedScope.join(",")
        : queries.scopeSelected || "";

    const effectiveClientType =
      selectedClientType.length > 0
        ? selectedClientType.join(",")
        : queries.selectedClientType || "";

    const effectiveSearch = search || queries.search || "";

    const effectiveSearchId =
      selectedSearches.length > 0
        ? selectedSearches
        : queries.search_id || selectedSearch;

    // Determine pagination values based on trigger
    // Allow caller to override page/limit (used during restore to avoid race)
    const payloadPage =
      override?.page ??
      (triggeredBy === "pagination"
        ? pagination.pageIndex + 1
        : queries.page || pagination.pageIndex + 1 || 1);

    const payloadLimit = override?.limit ?? pagination.pageSize;

    const queryPayload = {
      page: payloadPage,
      limit: payloadLimit,
      search: effectiveSearch,
      scopeSelected: effectiveScope,
      selectedClientType: effectiveClientType,
      search_id: effectiveSearchId,
      encodedCondition: encodedCondition || queries.encodedCondition,
    };

    // --- 3. REDUX DISPATCH GUARD (Breaks the infinite loop) ---

    // We only dispatch to Redux if this was a user-initiated action ("filter" or "pagination")
    // AND the new payload is actually different from the current Redux 'queries'.

    const currentQueriesRelevant = JSON.stringify({
      page: queries.page,
      limit: queries.limit,
      search: queries.search,
      scopeSelected: queries.scopeSelected,
      selectedClientType: queries.selectedClientType,
      search_id: queries.search_id,
    });

    const newPayloadRelevant = JSON.stringify({
      page: queryPayload.page,
      limit: queryPayload.limit,
      search: queryPayload.search,
      scopeSelected: queryPayload.scopeSelected,
      selectedClientType: queryPayload.selectedClientType,
      search_id: queryPayload.search_id,
    });

    const shouldDispatch =
      (triggeredBy === "filter" || triggeredBy === "pagination") &&
      currentQueriesRelevant !== newPayloadRelevant;

    if (shouldDispatch) {
      dispatch(setClientListQueries(queryPayload));
    }

    // --- 4. DATA FETCH EXECUTION ---

    try {
      setIsLoading(true);
      setIsContentLoading(true);

      const response = await dispatch(fetchClientLists(queryPayload)).unwrap();

      // Robust parsing for various API shapes used across codebase
      let listData: any[] = [];
      let countData: number = 0;

      if (Array.isArray(response?.data?.customerList)) {
        listData = response.data.customerList;
      } else if (Array.isArray(response?.customerList)) {
        listData = response.customerList;
      } else if (Array.isArray(response?.data?.data?.customerList)) {
        listData = response.data.data.customerList;
      } else if (Array.isArray(response?.data)) {
        // some endpoints return array directly in data
        listData = response.data;
      } else if (Array.isArray(response)) {
        listData = response;
      }

      countData =
        response?.data?.count ||
        response?.count ||
        response?.data?.data?.count ||
        0;

      setClient(listData);
      setRowCount(countData ?? 0);

      dispatch(resetReloadClientList());
    } catch (error) {
      console.error("Fetch Data Error:", error);
      showToast("Something went wrong while fetching data.", "", "error");
      setClient([]); // Clear list on error
      setRowCount(0);
    } finally {
      setIsLoading(false);
      setIsContentLoading(false);

      if (triggeredBy === "filter") {
        setApplyFilter(false);
      }
    }
  }

  function exportApi(customerId: any) {
    apiServices.exportToExcel
      .get(customerId)
      .then(async (response) => {
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "ClientData.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const getClientPartner = (id: any) => {
    apiServices.ClientPartnerSplit.getClientDetail(id)
      .then((res) => {
        setPartnerID(res.data.data.NameAndAddress.associated_with);
        dispatch(setPartnerIDs(res.data.data.NameAndAddress.associated_with));
        setClientPartner(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const clearExtractFilters = async () => {
    setIsLoading(true);

    // Reset UI state
    setSearchValue("");
    setSearch("");
    setSelectedScope([]);
    setSelectedClientType([]);
    setSelectedSearches([]);
    setSelectedSearch("");
    setClient([]);
    setRowCount(0);

    // Reset pagination to USER PREFERENCE
    setPagination({
      pageIndex: rawSavedPagination.pageIndex ?? 0,
      pageSize: rawSavedPagination.pageSize ?? 100,
    });

    // 🔥 Explicitly reset queries (DO NOT use clearClientListQueries)
    await dispatch(clearClientListQueries());

    // // Fetch clean list
    await fetchUsersData("reload");

    setIsLoading(false);
  };

  const handleSavePreference = async () => {
    setIsProcessing(true);

    dispatch(setTableColumnOrder({ tableName, columnOrder }));
    dispatch(setTableSorting({ tableName, sorting }));
    dispatch(setTablePagination({ tableName, pagination }));

    const updatedSettings = {
      ...userPreferences,
      tables: {
        ...tables,
        contextSpecific: {
          ...contextSpecific,
          [tableName]: {
            ...tableSettings,
            initialState: {
              ...tableInitialState,
              columnOrder,
              sorting,
              pagination,
            },
          },
        },
      },
    };

    try {
      const { message } = await dispatch(
        savePreferences(updatedSettings)
      ).unwrap();
      showToast(message, "", "success");
      setIsProcessing(false);
      setHasChanges(false);
    } catch (error) {
      setIsProcessing(false);
      console.error("Error saving preferences:", error);
      showToast("Error saving preferences", "", "error");
    }
  };

  // Original functions
  const handleAddSearchClick = () => {
    setIsDialogOpen(true);
  };

  const handleAddDialogBox = () => {
    setIsDialogOpens(true);
  };
  const handleMenuItemClick = (
    title: string,
    searchId: string,
    type: string
  ) => {
    dispatch(setSelectionType(type));

    setSelectedMenuItem((prev) =>
      prev.includes(title)
        ? prev.filter((item) => item !== title)
        : [...prev, title]
    );

    setSelectedSearches((prev: any) =>
      prev.includes(searchId)
        ? prev.filter((id: any) => id !== searchId)
        : [...prev, searchId]
    );

    setTypeOfExtract((prev: any) =>
      prev.includes(type)
        ? prev.filter((t: any) => t !== type)
        : [...prev, type]
    );
  };

  const handleCheckboxChange = (checked: boolean, item: any) => {
    if (!checked) {
      const updatedSelectedSearches = selectedSearches.filter(
        (id: any) => id !== item.SearchId
      );

      if (updatedSelectedSearches.length === 0) {
        setHasTableTwo(false);
        setHasTableOne(false);
        setSelectedItem("");
        setSelectedItemTwo("");
        setSelectedFieldName("");
        setSelectedFieldNameTableTwo("");
        setSelectedTableName("");
        setSelectedTableNameTwo("");
        setSelectedColumnName("");
        setSelectedColumnNameTwo("");
        setSelectedFieldType("");
        setSelectedFieldTypeTableTwo("");
        setIsPartner(false);
      } else {
        const lastSelectedId =
          updatedSelectedSearches[updatedSelectedSearches.length - 1];
        const lastSelectedItem = extract.find(
          (el: any) => el.SearchId === lastSelectedId
        );

        if (lastSelectedItem) {
          const condition = lastSelectedItem.Condition
            ? JSON.parse(lastSelectedItem.Condition)
            : {};
          const tableOne = condition?.tableOne ?? {};
          const tableTwo = condition?.tableTwo ?? {};

          setHasTableTwo(!!tableTwo.table);
          setHasTableOne(!!tableOne.table);
          setSelectedItem(tableOne.fieldValue ?? "");
          setSelectedItemTwo(tableTwo.fieldValue ?? "");
          setSelectedFieldName(tableOne.label ?? "");
          setSelectedFieldNameTableTwo(tableTwo.label ?? "");
          setSelectedTableName(tableOne.table ?? "");
          setSelectedTableNameTwo(tableTwo.table ?? "");
          setSelectedColumnName(tableOne.fieldName ?? "");
          setSelectedColumnNameTwo(tableTwo.fieldName ?? "");
          setSelectedFieldType(tableOne.fieldType ?? "");
          setSelectedFieldTypeTableTwo(tableTwo.fieldType ?? "");
          setSelectedItems(lastSelectedItem);
          setIsPartner(tableOne.partner ?? false);
        }
      }

      setSelectedSearches(updatedSelectedSearches);
      return;
    }

    const condition = item.Condition ? JSON.parse(item.Condition) : {};
    const tableOne = condition?.tableOne ?? {};
    const tableTwo = condition?.tableTwo ?? {};

    setHasTableTwo(!!tableTwo.table);
    setHasTableOne(!!tableOne.table);
    setSelectedItem(tableOne.fieldValue ?? "");
    setSelectedItemTwo(tableTwo.fieldValue ?? "");
    setSelectedFieldName(tableOne.label ?? "");
    setSelectedFieldNameTableTwo(tableTwo.label ?? "");
    setSelectedTableName(tableOne.table ?? "");
    setSelectedTableNameTwo(tableTwo.table ?? "");
    setSelectedColumnName(tableOne.fieldName ?? "");
    setSelectedColumnNameTwo(tableTwo.fieldName ?? "");
    setSelectedFieldType(tableOne.fieldType ?? "");
    setSelectedFieldTypeTableTwo(tableTwo.fieldType ?? "");
    setSelectedItems(item);
    setIsPartner(tableOne.partner ?? false);

    setSelectedSearches([...selectedSearches, item.SearchId]);
  };

  const renderedMenuItems = extract.map((item: any) => {
    const isSelected = selectedSearches.includes(item.SearchId);

    return (
      <div className={styles.fullWidthContainer} key={item.SearchId}>
        <Checkbox
          size="medium"
          checked={isSelected}
          onChange={(e) => {
            handleMenuItemClick(item.Title, item.SearchId, item.Type);
            handleCheckboxChange(e.target.checked, item);
          }}
          label={item.Title}
        />
      </div>
    );
  });

  const selectedTitles = selectedMenuItem.join(", ");
  const savedSearchesLabel = selectedTitles
    ? `${selectedTitles} (Saved Searches)`
    : "Saved Searches";

  // Merged useEffects from ClientDataList
  useEffect(() => {
    if (filterSelectionData.length > 0) {
      setClient(filterSelectionData);
    }
  }, [filterSelectionData]);

  // REFS
  const isRestoring = useRef(false);
  const didRestore = useRef(false);
  const didInitialFetch = useRef(false);

  /* ---------------------------------------------
   1️RESTORE QUERIES FROM REDUX (RUNS ONCE)
---------------------------------------------- */
  useEffect(() => {
    if (didRestore.current) return;

    didRestore.current = true;
    isRestoring.current = true;

    let hasFilters = false;

    if (!queries || Object.keys(queries).length === 0) {
      // Initial load with no saved queries
      setTimeout(() => {
        isRestoring.current = false;
        fetchUsersData("reload");
      }, 0);
      return;
    }

    if (queries.search) {
      setSearchValue(queries.search);
      setSearch(queries.search);
      hasFilters = true;
    }

    if (queries.scopeSelected) {
      const restored = queries.scopeSelected.split(",");
      setSelectedScope(restored);
      if (restored.length > 0) hasFilters = true;
    }

    if (queries.selectedClientType) {
      const restored = queries.selectedClientType.split(",");
      setSelectedClientType(restored);
      if (restored.length > 0) hasFilters = true;
    }

    if (queries.search_id) {
      const searchIdValue = Array.isArray(queries.search_id)
        ? queries.search_id.join(",")
        : queries.search_id;
      setSelectedSearch(searchIdValue);
      setSelectedSearches(
        Array.isArray(queries.search_id)
          ? queries.search_id
          : [queries.search_id]
      );
      hasFilters = true;
    }

    if (queries.encodedCondition) {
      setEncodedCondition(queries.encodedCondition);
      hasFilters = true;
    }

    // Apply filters if any filter existed
    if (hasFilters) {
      setTimeout(() => setApplyFilter(true), 0);
    }

    setTimeout(() => {
      isRestoring.current = false;
      const overridePage = queries.page;
      const overrideLimit = queries.limit;
      fetchUsersData("reload", { page: overridePage, limit: overrideLimit });
    }, 0);
    dispatch(setTablePagination({ tableName, pagination }));
  }, [queries, pagination.pageIndex, pagination.pageSize]);

  /* ---------------------------------------------
   2️ APPLY FILTER → TRIGGER FETCH
---------------------------------------------- */
  useEffect(() => {
    if (!applyFilter) return;

    fetchUsersData("filter"); // save filters + pagination to Redux
  }, [applyFilter]);

  /* ---------------------------------------------
   3️ PAGINATION CHANGE → TRIGGER FETCH
---------------------------------------------- */
  useEffect(() => {
    if (isRestoring.current || !didRestore.current) {
      return;
    }

    if (!didInitialFetch.current) {
      didInitialFetch.current = true;
      return;
    }

    // Always update queries Redux with new pagination
    dispatch(
      setClientListQueries({
        ...queries,
        page: queries.page
          ? pagination.pageIndex + 1
          : pagination.pageIndex + 1,
        limit: queries.limit ? queries.limit : pagination.pageSize,
      })
    );

    fetchUsersData("pagination");
  }, [pagination.pageIndex, pagination.pageSize]);

  /* ---------------------------------------------
   4 RELOAD TRIGGER (FROM OTHER SCREENS)
---------------------------------------------- */
  useEffect(() => {
    if (reloadList || isReloadClientList) {
      fetchUsersData("reload"); // fetch, but do NOT update Redux filters
    }
  }, [reloadList, isReloadClientList]);

  /* ---------------------------------------------
   5️ LOADING INDICATOR SYNC
---------------------------------------------- */
  // useEffect(() => {
  //   setIsLoading(IsContentloading);
  // }, [IsContentloading]);

  // Removed automatic fetch on search and scope change

  useEffect(() => {
    const selectedCustomerId = Object.keys(rowSelection)[0];
    if (selectedCustomerId) {
      const selectedCustomerValue = client.find(
        (c) => c.customer_id === selectedCustomerId
      );

      if (selectedCustomerValue && setActiveItem) {
        setActiveItem(selectedCustomerValue);
      }
    }
  }, [rowSelection, client, setActiveItem]);

  useEffect(() => {
    setRowSelection({ [activeClient.customer_id]: true });
  }, [activeClient]);

  useEffect(() => {
    if (preferenceStatus === "idle") {
      dispatch(fetchUserPreferences());
    }
  }, [preferenceStatus, dispatch]);

  useEffect(() => {
    if (preferenceStatus === "succeeded") {
      setColumnOrder(
        savedColumnOrder.length > 0
          ? savedColumnOrder
          : defaultTableConfig.tables.contextSpecific[tableName]?.initialState
              ?.columnOrder ?? []
      );
      setSorting(
        savedSorting.length > 0 ? savedSorting : sortingConfig.defaultSort ?? []
      );
      setPagination(
        savedPagination.pageSize ?? 100 > 0
          ? savedPagination
          : { pageIndex: 0, pageSize: 100 }
      );
      setHasChanges(false);
    }
  }, [
    preferenceStatus,
    savedColumnOrder,
    savedSorting,
    savedPagination,
    sortingConfig,
  ]);

  useEffect(() => {
    const hasColumnOrderChanged = !isEqual(columnOrder, savedColumnOrder);
    const hasSortingChanged = !isEqual(sorting, savedSorting);
    const hasPaginationChanged = !isEqual(pagination, savedPagination);

    setHasChanges(
      hasColumnOrderChanged || hasSortingChanged || hasPaginationChanged
    );
  }, [
    columnOrder,
    sorting,
    pagination,
    savedColumnOrderKey,
    savedSortingKey,
    savedPaginationKey,
  ]);

  const customColumns = useMemo<MRT_ColumnDef<any>[]>(() => {
    if (!columns || columns.length === 0) {
      return [];
    }

    return columns.map((col: any) => {
      const enhancedCol: MRT_ColumnDef<any> = { ...col };
      if (col.Cell) {
        switch (col.Cell) {
          case "formatedDate":
            enhancedCol.Cell = ({ row }) => (
              <>{formatedDate(row.original[col.accessorKey])}</>
            );
            break;
          case "ReactQuillComponent":
            enhancedCol.Cell = ({ row }) => (
              <ReactQuillComponent value={row.original[col.accessorKey]} />
            );
            break;
          default:
            break;
        }
      }
      return enhancedCol;
    });
  }, [columns]);

  const config = useMemo(
    () => ({
      ...(defaultConfig ?? {}),
      enablePagination: true,
      enableColumnOrdering: true,
      enableColumnDragging: true,
      enableMultiSort: sortingConfig?.enableMultiSort || false,
      enableSorting: true,
      manualSorting: false,
      initialState: {
        ...(defaultConfig.initialState ?? {}),
        density: "compact" as const,
        columnOrder,
        columnPinning: {
          right: ["mrt-row-actions"],
          left: ["mrt-row-select", "mrt-row-numbers"],
        },
        sorting,
        pagination,
      },
      ...(sortingConfig?.sortableColumns && {
        columns: customColumns.map((col) => ({
          ...col,
          enableSorting: sortingConfig.sortableColumns.includes(
            col.accessorKey as string
          ),
        })),
      }),
    }),
    [
      defaultConfig,
      columnOrder,
      sorting,
      pagination,
      sortingConfig,
      customColumns,
    ]
  );

  const currentSearchIdLength =
    selectedSearches.length > 0 || selectedSearch !== "";

  const isAnyFilterSet =
    selectedClientType.length > 0 ||
    (searchValue !== "" && selectedScope.length > 0);

  return (
    <div className="padding_20">
      <div className="flex-end">
        {checkUserPermission(
          loggedUser,
          UserPermissionsList.ALLOW_ADD_CLIENT
        ) && (
          <ASCButton
            shape="rounded"
            label="Add Client"
            className="asc-button-primary"
            appearance="primary"
            onClick={() => navigate(`/clients/add`)}
            size="medium"
          />
        )}
      </div>
      <div className="page-content-area" data-testid="page-content">
        {checkUserPermission(
          loggedUser,
          UserPermissionsList.ALLOW_VIEW_CLIENT
        ) && (
          <>
            <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
            {IsContentloading ? (
              <TableListLoader rows={10} columns={6} />
            ) : (
              <div className="client-list-wrapper">
                {customColumns.length > 0 && (
                  <MaterialReactTable
                    getRowId={(row: any) => row.customer_id}
                    rowCount={rowCount}
                    muiTableHeadCellProps={config.muiTableHeadCellProps}
                    muiToolbarAlertBannerProps={{ sx: { display: "none" } }}
                    muiTablePaginationProps={{
                      rowsPerPageOptions: [10, 50, 100, 200, 500],
                    }}
                    renderTopToolbarCustomActions={({ table }) => (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          overflowX: "auto",
                          overflowY: "hidden",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <div className="global-search-filter">
                          <Search
                            setSearch={setSearchValue}
                            search={searchValue}
                            isLoading={isLoading}
                            placeholder="Search by first name or last name"
                            width={"260px"}
                          />
                          <DropDownBox
                            disabled={
                              searchValue && searchValue !== "" ? false : true
                            }
                            placeholder={
                              selectedScope.length > 0
                                ? selectedScope
                                    .map(
                                      (s: string) =>
                                        s.charAt(0).toUpperCase() + s.slice(1)
                                    )
                                    .join(", ")
                                : "Scope"
                            }
                            multiselect={true}
                            values={scopeData}
                            selectedOptions={selectedScope}
                            onOptionSelect={(
                              event: any,
                              option: string | any
                            ) => {
                              setSelectedScope(option.selectedOptions);
                            }}
                          />
                          <ASCDropDown
                            placeholder={
                              selectedClientType.length > 0
                                ? selectedClientType.join(", ")
                                : "Client Type"
                            }
                            optionsFetcher={fetchClientTypeOptions}
                            // clearable
                            onSelectionChange={(selectedValue: any) => {
                              setSelectedClientType(selectedValue);
                            }}
                            style={{ minWidth: "min-content" }}
                            multiSelect={true}
                          />

                          {!convertStringToArray(
                            process.env.REACT_APP_HIDE_CTA_BUTTON
                          ).includes("saved_searches") ? (
                            <ASCButton
                              shape="rounded"
                              style={{
                                fontWeight: 400,
                                color: "#606060",
                                border: "1px solid grey",
                              }}
                              onClick={handleOpenSearches}
                              label={savedSearchesLabel}
                            />
                          ) : (
                            ""
                          )}

                          <ASCButton
                            shape="rounded"
                            disabled={!isAnyFilterSet}
                            label={"Apply"}
                            className={
                              isAnyFilterSet ? "asc-button-primary" : ""
                            }
                            appearance="primary"
                            onClick={() => {
                              setApplyFilter(true);
                            }}
                            size="medium"
                          />

                          {(currentSearchIdLength ||
                            filterSelectionData.length > 0 ||
                            selectedClientType.length > 0 ||
                            selectedScope.length > 0 ||
                            search !== "") && (
                            <ASCButton
                              shape="rounded"
                              icon={<FilterDismiss20Regular />}
                              size="medium"
                              onClick={clearExtractFilters}
                              // label="Clear Filter"
                            />
                          )}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                          }}
                        >
                          <ASCButton
                            shape="rounded"
                            icon={<ArrowClockwise20Regular />}
                            className="asc-button-secondary"
                            appearance="secondary"
                            onClick={handleResetToDefault}
                            // label="Reset to Default"
                          />

                          {!convertStringToArray(
                            process.env.REACT_APP_HIDE_CTA_BUTTON
                          ).includes("client_list_preference") && (
                            <ASCButton
                              shape="rounded"
                              className="asc-button-secondary"
                              appearance="secondary"
                              onClick={handleSavePreference}
                              label="Save Preference"
                              disabled={!hasChanges || isProcessing}
                            />
                          )}
                          {!convertStringToArray(
                            process.env.REACT_APP_HIDE_CTA_BUTTON
                          ).includes("saved_searches") && (
                            <Tooltip
                              content="Export"
                              relationship="label"
                              appearance="inverted"
                              positioning="below"
                              withArrow
                            >
                              {currentSearchIdLength ||
                              filterSelectionData?.length > 0 ? (
                                <IconButton
                                  onClick={handleOpen}
                                  disabled={
                                    !(
                                      currentSearchIdLength ||
                                      filterSelectionData?.length > 0
                                    )
                                  }
                                >
                                  <ArrowDownload20Filled />
                                </IconButton>
                              ) : null}
                            </Tooltip>
                          )}
                          {isOpenDialog && (
                            <ExportMain
                              searchIds={searchIds}
                              isOpen={isOpenDialog}
                              onClose={handleClose}
                              selectedTab={selectedTab}
                              typeOfExtract={typeOfExtract}
                              searchId={
                                selectedSearches.length > 0
                                  ? selectedSearches
                                  : selectedSearch
                              }
                            />
                          )}
                        </div>
                      </div>
                    )}
                    enableColumnPinning
                    enableRowActions
                    positionActionsColumn="last"
                    renderRowActions={({ row, table }) => (
                      <div className={styles.wrapper}>
                        {checkUserPermission(
                          loggedUser,
                          UserPermissionsList.ALLOW_VIEW_CLIENT
                        ) && (
                          <Tooltip
                            content="View"
                            relationship="label"
                            positioning="below"
                          >
                            <Button
                              shape="rounded"
                              appearance="subtle"
                              onClick={() => {
                                navigate(
                                  `clients/${
                                    row.original.associated_type == 1
                                      ? row.original.associated_with
                                      : row.original.customer_id
                                  }/name-and-address/view`
                                );
                              }}
                              icon={
                                <Eye16Filled primaryFill="var(--button-color)" />
                              }
                            />
                          </Tooltip>
                        )}
                        {checkUserPermission(
                          loggedUser,
                          UserPermissionsList.ALLOW_UPDATE_CLIENT
                        ) && (
                          <Tooltip
                            content="Edit"
                            relationship="label"
                            positioning="below"
                          >
                            <Button
                              shape="rounded"
                              appearance="subtle"
                              onClick={() => {
                                navigate(
                                  `clients/${
                                    row.original.associated_type == 1
                                      ? row.original.associated_with
                                      : row.original.customer_id
                                  }/name-and-address/edit`
                                );
                              }}
                              icon={
                                <Edit16Filled primaryFill="var(--button-color)" />
                              }
                            />
                          </Tooltip>
                        )}
                        {(checkUserPermission(
                          loggedUser,
                          UserPermissionsList.ALLOW_CLIENT_EXPORTS
                        ) ||
                          checkUserPermission(
                            loggedUser,
                            UserPermissionsList.ALLOW_UPDATE_CLIENT
                          )) && (
                          <Menu>
                            <MenuTrigger disableButtonEnhancement>
                              <Button
                                shape="rounded"
                                appearance="subtle"
                                icon={
                                  <MoreHorizontal24Filled primaryFill="gray" />
                                }
                              />
                            </MenuTrigger>
                            <MenuPopover>
                              <MenuList>
                                {checkUserPermission(
                                  loggedUser,
                                  UserPermissionsList.ALLOW_CLIENT_EXPORTS
                                ) && (
                                  <MenuItem
                                    onClick={() =>
                                      exportApi(row.original.customer_id)
                                    }
                                  >
                                    Export to Excel
                                  </MenuItem>
                                )}
                                <MenuItem
                                  disabled={!row.original.email}
                                  onClick={() =>
                                    openSendMailDialog(
                                      row.original.customer_id,
                                      row.original.first_names,
                                      row.original.last_name
                                    )
                                  }
                                >
                                  Send Mail
                                </MenuItem>
                                {!convertStringToArray(
                                  process.env.REACT_APP_HIDE_CTA_BUTTON
                                ).includes("client_partner_split") ? (
                                  <MenuItem
                                    onClick={() => {
                                      OpenSplitComponent(
                                        row.original.customer_id
                                      );
                                      getClientPartner(
                                        row.original.customer_id
                                      );
                                    }}
                                    disabled={
                                      row.original.associated_with === null
                                    }
                                  >
                                    Split
                                  </MenuItem>
                                ) : (
                                  ""
                                )}
                              </MenuList>
                            </MenuPopover>
                          </Menu>
                        )}
                      </div>
                    )}
                    columns={customColumns}
                    data={client}
                    enableRowSelection={config.enableRowSelection}
                    enableColumnActions={config.enableColumnActions}
                    enableColumnOrdering={config.enableColumnOrdering}
                    enableColumnDragging={config.enableColumnDragging}
                    onColumnOrderChange={handleColumnOrderChange}
                    enableSorting={config.enableSorting}
                    manualSorting={config.manualSorting}
                    enablePagination={config.enablePagination}
                    enableMultiRowSelection={config.enableMultiRowSelection}
                    enableColumnFilters={config.enableColumnFilters}
                    enableGlobalFilter={config.enableGlobalFilter}
                    enableDensityToggle={config.enableDensityToggle}
                    manualPagination={config.manualPagination}
                    manualFiltering={config.manualFiltering}
                    initialState={config.initialState}
                    muiTableProps={config.muiTableProps}
                    muiTableBodyRowProps={({ row }) => ({
                      ...config.muiTableBodyRowProps,
                      onClick: row.getToggleSelectedHandler(),
                    })}
                    icons={{
                      DragHandleIcon: () => (
                        <ArrowSwap20Regular
                          style={{ color: "000", cursor: "grab" }}
                        />
                      ),
                    }}
                    onPaginationChange={handlePaginationChange}
                    onRowSelectionChange={setRowSelection}
                    onSortingChange={handleSortingChange}
                    onColumnVisibilityChange={setColumnVisibility}
                    state={{
                      rowSelection,
                      pagination,
                      columnOrder,
                      sorting,
                      columnVisibility,
                    }}
                  />
                )}

                {popupVisible && (
                  <div
                    className={styles.popup}
                    style={{ top: popupPosition.top, left: popupPosition.left }}
                  >
                    <Label weight="semibold">Headline Note</Label>
                    <Tooltip
                      withArrow
                      content="Example tooltip with an arrow"
                      relationship="label"
                    >
                      <ReactQuillComponent value={popupData ?? ""} />
                    </Tooltip>
                  </div>
                )}
              </div>
            )}

            {isSendMailDialogOpen && (
              <SendMail
                openSendMailDialog={openSendMailDialog}
                isSendMailDialogOpen={isSendMailDialogOpen}
                closeSendMailDialog={closeSendMailDialog}
                selectClient={selectClient}
                reloadList={setReloadList}
                notify={showToast}
              />
            )}
            {tabOpen && (
              <MainTab
                extract={extract}
                setIsDialogOpens={setIsDialogOpens}
                handleAddDialogBox={handleAddDialogBox}
                setSelectedItem={setSelectedItem}
                selectedItem={selectedItem}
                setSelectedItemTwo={setSelectedItemTwo}
                hasTableTwo={hasTableTwo}
                handleAddSearchClick={handleAddSearchClick}
                selectedMenuItem={selectedMenuItem}
                renderedMenuItems={
                  <>
                    {selectedItem && (
                      <div style={{ padding: "10px", fontWeight: "bold" }}>
                        Selected Item: {selectedItem}
                      </div>
                    )}
                    {renderedMenuItems}
                  </>
                }
                getExtracts={getExtracts}
                handleSearchId={handleSearchId}
                applyFilter={applyFilter}
                setApplyFilter={setApplyFilter}
                setSearchIds={setSearchIds}
                searchIds={searchIds}
                selectedSearch={selectedSearch}
                setSelectedSearch={setSelectedSearch}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                setTypeOfExtract={setTypeOfExtract}
                selectedSearches={selectedSearches}
                setSelectedSearches={setSelectedSearches}
                setTabOpen={setTabOpen}
                getDialogState={tabOpen}
                closeMainTabDialog={handleCloseMainTab}
                initialLoader={initialLoader}
              />
            )}
            <MainPage
              isOpen={openSplit}
              ClientPartner={ClientPartner}
              onClose={handleCloseSplit}
              partnerID={partnerID}
            />
          </>
        )}
        <ModalDialog options={dialogModalOptions} />
      </div>
      {isDialogOpen && (
        <Dialog
          modalType="non-modal"
          open={isDialogOpen}
          onOpenChange={(_, data) => setIsDialogOpen(data.open)}
        >
          <DialogSurface style={{ maxWidth: "75vw" }}>
            <DialogBody>
              <DialogTitle>Extract by Condition</DialogTitle>
              <DialogContent>
                <ExtractMain
                  setIsDialogOpen={setIsDialogOpen}
                  appliedId={handleSearchId}
                  extract={extract}
                  setExtract={setExtract}
                  getExtracts={getExtracts}
                  setTabOpen={setTabOpen}
                />
              </DialogContent>
            </DialogBody>
          </DialogSurface>
        </Dialog>
      )}

      <Dialog
        modalType="non-modal"
        open={isDialogOpens}
        onOpenChange={(_, data) => setIsDialogOpens(data.open)}
      >
        <DialogSurface>
          <DialogBody>
            <DialogTitle></DialogTitle>
            <DialogContent>
              <ValuePrediction
                selectedItem={selectedItem}
                isPartner={isPartner}
                hasTableTwo={hasTableTwo}
                selectedItemTwo={selectedItemTwo}
                setEncodedCondition={setEncodedCondition}
                encodedCondition={encodedCondition}
                setIsDialogOpens={setIsDialogOpens}
                selectedFieldName={selectedFieldName}
                selectedFieldNameTableTwo={selectedFieldNameTableTwo}
                selectedTableName={selectedTableName}
                selectedTableNameTwo={selectedTableNameTwo}
                selectedColumnName={selectedColumnName}
                selectedColumnNameTwo={selectedColumnNameTwo}
                selectedItems={selectedItems}
                setIsDialogOpen={setIsDialogOpen}
                searchId={handleSearchId}
                extract={extract}
                setExtract={setExtract}
                getExtracts={getExtracts}
                setTabOpen={setTabOpen}
                setApplyFilter={setApplyFilter}
                tableName={selectedTableName}
                columnName={selectedColumnName}
                selectedFieldType={selectedFieldType}
                selectedFiledTypeTableTwo={selectedFiledTypeTableTwo}
              />
            </DialogContent>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
};

export default List;
